import React, { FormEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { login } from './actions';
import { selectAuthenticated, selectError, selectLoggingIn } from './selectors';
import { Button } from '../Controls';
import { ErrorText, Field, Input } from './styled';

const Form = () => {
  const dispatch = useDispatch();

  const authenticated = useSelector(selectAuthenticated)
  const error = useSelector(selectError)
  const loggingIn = useSelector(selectLoggingIn)

  const [email, changeEmail] = useState('');
  const [password, changePassword] = useState('');

  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  return (
    <form onSubmit={handleSubmit}>
      <Field>
        <label htmlFor="email">Email</label>
        <Input
          type="email" name="email" id="email" autoComplete="username"
          onChange={({ target: { value } }) => changeEmail(value)}
          value={email}
        />
      </Field>
      <Field>
        <label htmlFor="password">Password</label>
        <Input
          type="password" name="password" id="password" autoComplete="current-password"
          onChange={({ target: { value } }) => changePassword(value)}
          value={password}
        />
      </Field>
      {error && <ErrorText role="alert">{error}</ErrorText>}
      <Button $primary $block disabled={loggingIn}>{loggingIn ? 'Logging in…' : 'Log in'}</Button>
    </form>
  );
};

export default Form;
